// extracted by mini-css-extract-plugin
module.exports = {"content":"hero_content__31Mbu","link":"hero_link__aV_kd","heading":"hero_heading__-q7CW","subheading":"hero_subheading__nVoUa"};